/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TownVm,
    TownVmFromJSON,
    TownVmFromJSONTyped,
    TownVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface TownVmPaginatedSearchResponse
 */
export interface TownVmPaginatedSearchResponse {
    /**
     * 
     * @type {Array<TownVm>}
     * @memberof TownVmPaginatedSearchResponse
     */
    items?: Array<TownVm> | null;
    /**
     * 
     * @type {number}
     * @memberof TownVmPaginatedSearchResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof TownVmPaginatedSearchResponse
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof TownVmPaginatedSearchResponse
     */
    to?: number;
    /**
     * 
     * @type {number}
     * @memberof TownVmPaginatedSearchResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof TownVmPaginatedSearchResponse
     */
    size?: number;
}

export function TownVmPaginatedSearchResponseFromJSON(json: any): TownVmPaginatedSearchResponse {
    return TownVmPaginatedSearchResponseFromJSONTyped(json, false);
}

export function TownVmPaginatedSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TownVmPaginatedSearchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(TownVmFromJSON)),
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
    };
}

export function TownVmPaginatedSearchResponseToJSON(value?: TownVmPaginatedSearchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(TownVmToJSON)),
        'totalCount': value.totalCount,
        'from': value.from,
        'to': value.to,
        'page': value.page,
        'size': value.size,
    };
}


